import {
  FormControl,
  FormHelperText,
  FormLabel,
  Textarea,
} from '@chakra-ui/react';

import {useFormContext} from 'react-hook-form';

import {QuestionProps} from './question';

export function TextareaQuestion(props: Readonly<QuestionProps>) {
  const {question} = props;
  const {register} = useFormContext();

  return (
    <FormControl key={question.id}>
      <FormLabel>{question.title}</FormLabel>
      <Textarea {...register(question.id)} />
      <FormHelperText>{question.description}</FormHelperText>
    </FormControl>
  );
}
